import React, { Component } from "react";
import { connect } from "react-redux";
import { Container } from "reactstrap";
import SurveyForm from "./SurveyForm";
import privateView from "../../components/hocs/privateView";
import Analytics from "../../services/Analytics";

class SurveyDetail extends Component {
  componentDidMount() {
    const { email } = this.props.injectedProps;
    Analytics.recordPageView("survey_detail", email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match,
    });
  }
  render() {
    return (
      <Container fluid>
        <SurveyForm edit title="Survey Detail" {...this.props} />
      </Container>
    );
  }
}

const mapStateToProps = ({
  auth: { isFetch, roles, isLogged, id, email },
}) => ({
  guardData: { isFetch, roles, isLogged, id, email },
});

const enhance = connect(mapStateToProps);
export default enhance(privateView(SurveyDetail));
